export const MemberDetails = {
  MEMBERSHIP_PRICE: 'membershipPrice',
};
